export const addElementToArrayIfTrue = (element: any, condition: boolean) => (condition ? [element] : []);

export const getRandomId = () => {
  return `id_${Math.floor(Math.random() * 1000000).toString()}`;
};
